import type { FC } from "react";

export interface SpinnerProps {
	size?: "sm" | "md" | "lg";
	className?: string;
}

const sizeClasses: Record<string, string> = {
	sm: "h-4 w-4 border-2",
	md: "h-6 w-6 border-2",
	lg: "h-10 w-10 border-3",
};

export const Spinner: FC<SpinnerProps> = ({ size = "md", className = "" }) => {
	return (
		<span
			role="status"
			aria-label="Loading"
			className={`inline-block animate-spin rounded-full border-current border-r-transparent ${sizeClasses[size]} ${className}`}
		/>
	);
};
